// Written in this round about way for babel-transform-imports
import MemoryRouter from "react-router/es/MemoryRouter";

export default MemoryRouter;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-router-dom/es/MemoryRouter.js
// module id = 441
// module chunks = 4 5 6 7